import React from 'react'
import { User } from '../Shared/common_defs'
import CollapsibleSection from '../Shared/CollapsibleSection'
import { Loading, Message, Table, Text } from '@workwhile/ui'
import { useUserExternalTraining } from 'queries/user/useUserExternalTraining'
import { formatDate, formatDistanceToNowStrict } from 'date-fns'

interface Props {
  user: User
}

const COLUMNS = [
  {
    header: 'Type',
    accessorKey: 'trainingType',
  },
  {
    header: 'Status',
    accessorKey: 'status',
  },
  {
    header: 'Provider',
    accessorKey: 'provider',
  },
  {
    header: 'Learner ID',
    accessorKey: 'externalLearnerId',
  },
  {
    header: 'Next Due Date',
    accessorKey: 'nextDueAt',
    cell: ({ row }) => {
      const value = row.original.nextDueAt
      if (!value) return '—'
      return (
        <>
          <Text title={formatDate(value, 'MMM dd, yyyy, hh:mm a')}>
            {formatDate(value, 'MMM dd, yyyy')}
          </Text>
          <Text color="lightText">
            ({formatDistanceToNowStrict(value, { addSuffix: true })})
          </Text>
        </>
      )
    },
  },
]

const UserExternalTrainingInfo = ({ user }: Props) => {
  const userId = user.id ? Number(user.id) : 0
  const { data, isLoading, isError } = useUserExternalTraining(userId)

  const renderContent = () => {
    if (isLoading) return <Loading />
    if (isError) {
      return (
        <Message variant="error">
          Failed to load external training details. Please try again.
        </Message>
      )
    }
    if (!data || data.length === 0)
      return <p>User has no external training info.</p>
    return <Table data={data} columns={COLUMNS} />
  }

  return (
    <CollapsibleSection title="External Training Info">
      {renderContent()}
    </CollapsibleSection>
  )
}

export default UserExternalTrainingInfo
